<template>
  <div>
    <div class="text-[#fff]">{{ title }}</div>
    <ul class="text-sm">
      <li v-for="(item, index) in list" :key="index" class="my-4">
        <div v-if="Array.isArray(item)" class="flex">
          <div
            v-for="({ content, ...attr }, index) in item"
            :key="index"
            v-bind="attr"
          >
            {{ content }}
          </div>
        </div>
        <template
          v-else-if="typeof item === 'object' && item && !Array.isArray(item)"
        >
          <NuxtLink
            v-if="item.to"
            :to="item.to"
            class="hover:underline cursor-pointer"
            >{{ item.content }}</NuxtLink
          >
          <span v-else>{{ item.content }}</span>
        </template>
        <template v-else>
          {{ item as string }}
        </template>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  title: {
    type: String,
    required: true
  },
  list: {
    type: Array as PropType<
      Array<
        string | { content: string; to?: string } | Record<string, string>[]
      >
    >,
    default() {
      return []
    }
  }
})
</script>

<style lang="scss" scoped></style>
